import "./Contact.css";
import Button from "../Button/Button";
import contact1 from "../../assets/contact/contact_1.jpg";
import contact2 from "../../assets/contact/contact2.png";

function Contact() {
  return (
    <div className="contact">
      <div className="contact-first">
        <h2>ARE YOU PLANNING YOUR VACATION?</h2>
      </div>
      <div className="contact-second">
        <div className="left">
          <img src={contact1} alt="contact" />
        </div>
        <div className="right">
          <div className="text">
            <h5>
              SHARE WITH US AND WE WILL PREPARE OFFERS FOR AN UNFORGETTABLE TRIP
            </h5>
            <Button
              buttonName="GET IN TOUCH WITH US"
              theme="dark"
              to="/contact"
            />
          </div>
          <div className="img">
            <img src={contact2} alt="contact" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
